import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/SchoolFill.tsx
const SchoolFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2 2.5a.5.5 0 0 1 .5-.5h3.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2.6v.507c.014.011.03.023.044.036l5 4.21a1 1 0 0 1 .356.765V12h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3v-.482a1 1 0 0 1 .356-.765l4.843-4.078V2.5ZM12 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
		fill: props.fill || "currentColor"
	})
}));
export { SchoolFillIcon };
